import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const products = [
  { title: 'HOME',     source: '/',         id: 1 },
  { title: 'ABOUT',    source: '/about',    id: 3 },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const closeMenu = () => setIsOpen(false);

  const listItems = products.map(product => (
    <li key={product.id} className="nav-item">
      <Link to={product.source} className="nav-link" onClick={closeMenu}>
        {product.title}
      </Link>
    </li>
  ));

  return (
    <nav className="navbar">
      <div className="navbar-inner">

        {/* Logo + Brand */}
        <div className="brand">
          <img src="/logo.png" alt="Logo" className="logo" />
          <span className="brand-text">JUNEBASE ROBOTICS</span>
        </div>

        {/* Desktop Links */}
        <div className="nav-links">
          <ul>{listItems}</ul>
        </div>

        {/* Hamburger */}
        <div className="hamburger" onClick={toggleMenu}>
          <div className="hamburger-line" />
          <div className="hamburger-line" />
          <div className="hamburger-line" />
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <ul>{listItems}</ul>
      </div>
    </nav>
  );
}